/**
 *  @moduleName: NgContentComponentsModule
 *  @moduleImport: @al/ng-content-components
 *
 *  Please DO NOT modify this file directly.  It is regenerated automatically by running 'npm run restructurate'.  Ask Kevin if you have questions!
 */

import { AlCompoundContentComponent } from './al-compound-content/al-compound-content.component';
import { AlMarkdownContentComponent } from './al-compound-content/markdown/al-markdown-content.component';
import { AlContentHeaderComponent } from './al-content-header/al-content-header.component';
import { AlContentToolbarComponent } from './al-content-toolbar/al-content-toolbar.component';
import { AlHighlightTextComponent } from './al-highlight-text/highlight-text.component';
import { AlJsonViewerComponent } from './al-json-viewer/al-json-viewer.component';
import { AlSegment } from './al-json-viewer/al-json-viewer.types';
import { AlPayloadViewerComponent, SearchIndex } from './al-payload-viewer/al-payload-viewer.component';
import { AlReactWrapperComponent } from './al-react-wrapper/al-react-wrapper.component';
import { AlTableCaptionV2Component, DynamicTableColumns } from './al-table-caption-v2/al-table-caption-v2.component';
import { AlTableCaptionComponent } from './al-table-caption/al-table-caption.component';
import { AlMarkdownToHtmlPipe } from './pipes/al-markdown-to-html.pipe';
import {
    HighlightTextService, 
    Match, 
    MatchingIds, 
    MatchType, 
    QuickSearch, 
    StringSearchObj
} from './services/highlight-text.service';
import {
    AlAnyContentDescriptor, 
    AlBaseContentDescriptor, 
    AlContentInterpreter, 
    AlErrorContentDescriptor, 
    AlImageContentDescriptor, 
    AlJsonContentDescriptor, 
    AlMapContentDescriptor, 
    AlMarkdownContentDescriptor, 
    AlTableContentDescriptor, 
    AlTimelineContentDescriptor
} from './types/al-compound-content.types';
import { AlHtmlMatch, AlHtmlToJsonParser } from './types/al-html-to-json.parser';


const MODULE_COMPONENTS = [
    AlCompoundContentComponent,
    AlContentHeaderComponent,
    AlContentToolbarComponent,
    AlHighlightTextComponent,
    AlJsonViewerComponent,
    AlMarkdownContentComponent,
    AlPayloadViewerComponent,
    AlReactWrapperComponent,
    AlTableCaptionComponent,
    AlTableCaptionV2Component,
];

const MODULE_DIRECTIVES = [

];

const MODULE_PIPES = [
    AlMarkdownToHtmlPipe,
];

const MODULE_SERVICES = [
    HighlightTextService,
];


export {
    MODULE_COMPONENTS,
    MODULE_DIRECTIVES,
    MODULE_PIPES,
    MODULE_SERVICES,
        AlAnyContentDescriptor,
    AlBaseContentDescriptor,
    AlCompoundContentComponent,
    AlContentHeaderComponent,
    AlContentInterpreter,
    AlContentToolbarComponent,
    AlErrorContentDescriptor,
    AlHighlightTextComponent,
    AlHtmlMatch,
    AlHtmlToJsonParser,
    AlImageContentDescriptor,
    AlJsonContentDescriptor,
    AlJsonViewerComponent,
    AlMapContentDescriptor,
    AlMarkdownContentComponent,
    AlMarkdownContentDescriptor,
    AlMarkdownToHtmlPipe,
    AlPayloadViewerComponent,
    AlReactWrapperComponent,
    AlSegment,
    AlTableCaptionComponent,
    AlTableCaptionV2Component,
    AlTableContentDescriptor,
    AlTimelineContentDescriptor,
    DynamicTableColumns,
    HighlightTextService,
    Match,
    MatchingIds,
    MatchType,
    QuickSearch,
    SearchIndex,
    StringSearchObj,
};

export * from './al-json-viewer/al-json-viewer.types';
export * from './types/al-compound-content.types';
export * from './types/al-html-to-json.parser';
export * from './al-payload-viewer/al-payload-viewer.component';
export * from './al-table-caption-v2/al-table-caption-v2.component';
export * from './services/highlight-text.service';